import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createVNode as _createVNode, vShow as _vShow, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref } from 'vue';
import ShowHideButton from '../ShowHideButton/ShowHideButton.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ExpandableContent',
  props: {
    toggleButtonExpandText: {},
    toggleButtonCollapseText: {},
    dynamicExpander: { type: Boolean },
    centerToggle: { type: Boolean }
  },
  setup(__props: any) {



const expanded = ref<boolean>(false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _renderSlot(_ctx.$slots, "introContent"),
    _withDirectives(_createElementVNode("div", {
      class: _normalizeClass({ 'flex justify-center': _ctx.centerToggle })
    }, [
      _createVNode(ShowHideButton, {
        showMore: expanded.value,
        showMoreLabel: _ctx.toggleButtonExpandText,
        showLessLabel: _ctx.toggleButtonCollapseText,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (expanded.value = !expanded.value))
      }, null, 8, ["showMore", "showMoreLabel", "showLessLabel"])
    ], 2), [
      [_vShow, (_ctx.dynamicExpander && !expanded.value) || !_ctx.dynamicExpander]
    ]),
    _withDirectives(_createElementVNode("div", {
      class: _normalizeClass({ 'mt-6': expanded.value && !_ctx.centerToggle })
    }, [
      _renderSlot(_ctx.$slots, "conditionalContent")
    ], 2), [
      [_vShow, expanded.value]
    ]),
    _withDirectives(_createElementVNode("div", {
      class: _normalizeClass({ 'flex justify-center': _ctx.centerToggle })
    }, [
      _createVNode(ShowHideButton, {
        showMore: expanded.value,
        showMoreLabel: _ctx.toggleButtonExpandText,
        showLessLabel: _ctx.toggleButtonCollapseText,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (expanded.value = !expanded.value))
      }, null, 8, ["showMore", "showMoreLabel", "showLessLabel"])
    ], 2), [
      [_vShow, _ctx.dynamicExpander && expanded.value]
    ])
  ]))
}
}

})